import {
  AnchorButton,
  Button,
  Classes,
  Code,
  Dialog,
  Overlay,
  DialogProps,
  H5,
  Switch,
  DialogFooter,
  DialogBody,
  FormGroup,
  InputGroup,
  Slider,
  HTMLSelect,
} from "@blueprintjs/core";
import { useCallback, useState } from "react";
import { useStyle } from "../style/style-context";

function StylesDialog({ ...props }) {
  console.log("StylesDialog", props);
  const { style, setStyle } = useStyle()

  const [state, setState] = useState(style)
  const nodeThemeOptions = ["Цветная", "Черно-белая"];

  const mapStyleToOption = (style) => {
    if (style === 'color') return nodeThemeOptions[0]
    if (style === 'black-white') return nodeThemeOptions[1]
  }

  const mapOptionToStyle = (option) => {
    if (option === nodeThemeOptions[0]) return 'color'
    if (option === nodeThemeOptions[1]) return 'black-white'
  }

  const onConfirm = (e) => {
    e.preventDefault()
    setStyle(state)
    props.onClose()
  }

  return (
    <Dialog isOpen={props.isOpen} onClose={props.onClose} title="Настройки">
      <DialogBody>
        <FormGroup
          label="Минимальный размер вершины"
          labelFor="min-node-size"
        >
          <Slider
            id="min-node-size"
            min={10}
            max={100}
            stepSize={1}
            value={state.node_min_size}
            onChange={(value) => {
              setState({ ...state, 'node_min_size': value, node_max_size: state.node_max_size < value ? value : state.node_max_size })
            }}
            labelStepSize={10}
          />
        </FormGroup>
        <FormGroup
          label="Максимальный размер вершины"
          labelFor="max-node-size"
        >
          <Slider
            id="max-node-size"
            min={10}
            max={100}
            stepSize={1}
            value={state.node_max_size}
            onChange={(value) => {
              if (value >= state.node_min_size) {
                setState({ ...state, 'node_max_size': value })
              }
            }}
            labelStepSize={10}
          />
        </FormGroup>

        <FormGroup
          label="Цветовая схема вершин"
          labelFor="max-node-size"
        >
          <HTMLSelect options={nodeThemeOptions}
            fill={true}
            value={mapStyleToOption(state.node_theme)}
            onChange={(e) => {
              setState({ ...state, 'node_theme': mapOptionToStyle(e.currentTarget.value) })
            }} />
        </FormGroup>
      </DialogBody>
      <DialogFooter actions={<Button intent="primary" text="Применить" onClick={onConfirm} />} />
    </Dialog>
  );
}
export default StylesDialog;
